export default {
    date: {
        fontSize: 16,
        marginBottom: -6
    },
    dateContainer: {
        width: 60,
        height: 60,
        borderRadius: '50%',
        background: '#f6e58d',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
    },
    month: {
        fontSize: 11
    }
};


// WEBPACK FOOTER //
// ./src/components/dateInList/dateInList.styles.js